import React from "react";
import Tags from "@yaireo/tagify/react";
import { useState } from "react";
import { useEffect } from "react";

const TagInput = ({ onChange, onInput, ...props }) => {
  const [tagifyProps, setTagifyProps] = useState({});

  // on component mount
  useEffect(() => {
    setTagifyProps({ loading: true });
    setTimeout(
      () =>
        setTagifyProps((lastProps) => ({
          ...lastProps,
          showFilteredDropdown: false,
        })),
      5000
    );
  }, []);
  return (
    <Tags
      onChange={(data) => {
        let text = data?.detail?.value ?? " ";
        onChange(text.trim() === "" ? [] : JSON.parse(data?.detail?.value ?? " "));
      }}
      {...props}
    />
  );
};

export default TagInput;
